import { Component } from '@angular/core'

@Component({
	selector: 'under-construction', 
	templateUrl: "./underConstruction.html" , 
	styleUrls : ["./underConstruction.css"] 
})

export class UnderConstructionComponent {
} 